import "./CompanyDetails.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import CompanyDetailsComponentController from "./CompanyDetailsComponentController";

export default class CompanyDetailsComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            companyId: "<",
        };
        this.controller = CompanyDetailsComponentController;
        this.templateUrl = "/App/Components/Companies/Details/CompanyDetails.html";
    }
}

module("mmManagePortal").component("irCompanyDetails", new CompanyDetailsComponent());
